import { isServer } from '@tunein/web-utils';
import axios from 'axios';
import { omit } from 'es-toolkit';
import { handleOpmlError } from '../errors/OpmlError';
import transformOpmlResponseHead from '../transforms/transformOpmlResponseHead';
import tuneInRequest from '../tuneInRequest';
export default function subscriptionService(config, apiContext, applyReauth) {
    const proxyEndpoint = `${config.domains.local}`;
    const accountsApiEndpoint = `${config.domains.opml}/Account.ashx`;
    const loopback = `${config.domains.loopback}${proxyEndpoint}`;
    const loopbackOrProxyEndpoint = isServer() ? loopback : proxyEndpoint;
    const productsEndpoint = `${loopbackOrProxyEndpoint}/products`;
    const subscriptionEndpoint = `${loopbackOrProxyEndpoint}/subscriptions`;
    const revCatReceiptEndpoint = 'https://api.revenuecat.com/v1/receipts';
    function getDefaultProduct(params) {
        return tuneInRequest({
            method: 'get',
            url: `${productsEndpoint}/default/`,
            disableCamelCase: true,
            noAuthHeader: true,
            params,
        }, apiContext);
    }
    function getProductBySku(params) {
        return tuneInRequest({
            method: 'get',
            url: `${productsEndpoint}/${params.sku}/`,
            disableCamelCase: true,
            noAuthHeader: true,
            params: omit(params, ['sku']),
        }, apiContext);
    }
    function getProductsBySkus(params) {
        return tuneInRequest({
            method: 'get',
            url: `${productsEndpoint}/list/?${params.skus}`,
            disableCamelCase: true,
            noAuthHeader: true,
            params: omit(params, ['skus']),
        }, apiContext);
    }
    function getSubscription(params) {
        return tuneInRequest({
            method: 'get',
            url: `${subscriptionEndpoint}/get/`,
            params,
        }, apiContext);
    }
    function createSubscription(params, data) {
        return tuneInRequest({
            method: 'post',
            url: `${subscriptionEndpoint}/create/`,
            params,
            data,
            disableRetry: true,
        }, apiContext);
    }
    function createCustomer(params) {
        return tuneInRequest({
            method: 'post',
            url: `${subscriptionEndpoint}/createCustomer/`,
            params,
            disableRetry: true,
        }, apiContext);
    }
    function createIntent(params) {
        return tuneInRequest({
            method: 'post',
            url: `${subscriptionEndpoint}/createIntent/`,
            params,
            disableRetry: true,
        }, apiContext);
    }
    function renewSubscription(params, data) {
        return tuneInRequest({
            method: 'post',
            url: `${subscriptionEndpoint}/renew/`,
            params,
            data,
            disableRetry: true,
        }, apiContext);
    }
    function cancelSubscription(params) {
        return tuneInRequest({
            method: 'post',
            url: `${subscriptionEndpoint}/cancel/`,
            params,
        }, apiContext);
    }
    function cancelIncompleteSubscription(params) {
        return tuneInRequest({
            method: 'post',
            url: `${subscriptionEndpoint}/cancelIncomplete/`,
            params,
        }, apiContext);
    }
    function linkExistingSubscription(params) {
        return tuneInRequest({
            method: 'post',
            url: `${subscriptionEndpoint}/linkExistingSubscription/`,
            params,
            disableRetry: true,
        }, apiContext);
    }
    function linkSubscription(params) {
        return tuneInRequest({
            method: 'post',
            url: accountsApiEndpoint,
            params: {
                ...params,
                c: 'linkSubscription',
            },
            disableRetry: true,
            transformResponse: transformOpmlResponseHead,
        }, apiContext).then(handleOpmlError);
    }
    function getPaymentInformation(params) {
        return tuneInRequest({
            method: 'get',
            url: `${subscriptionEndpoint}/payment/`,
            disableRetry: true,
            params,
        }, apiContext);
    }
    function updatePaymentInformation(params, data) {
        return tuneInRequest({
            method: 'put',
            url: `${subscriptionEndpoint}/payment/`,
            params,
            data,
            disableRetry: true,
        }, apiContext);
    }
    function lookupCoupon(params) {
        return tuneInRequest({
            method: 'get',
            url: `${loopbackOrProxyEndpoint}/coupons/${params.couponCode}/`,
            params: omit(params, ['couponCode']),
            disableRetry: true,
            disableCamelCase: true,
        }, apiContext);
    }
    function postReceiptToRevCat(stripeSubscriptionId, tuneInUserGuideId) {
        return axios({
            url: revCatReceiptEndpoint,
            method: 'POST',
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${config.revCatApiKey}`,
                'Content-Type': 'application/json',
                'X-Platform': 'stripe',
            },
            data: JSON.stringify({
                fetch_token: stripeSubscriptionId,
                app_user_id: tuneInUserGuideId,
            }),
        });
    }
    return {
        getDefaultProduct,
        getProductBySku,
        getProductsBySkus,
        lookupCoupon,
        postReceiptToRevCat,
        getSubscription: applyReauth(getSubscription),
        cancelSubscription: applyReauth(cancelSubscription),
        cancelIncompleteSubscription: applyReauth(cancelIncompleteSubscription),
        getPaymentInformation: applyReauth(getPaymentInformation),
        updatePaymentInformation: applyReauth(updatePaymentInformation),
        createSubscription: applyReauth(createSubscription),
        renewSubscription: applyReauth(renewSubscription),
        linkSubscription: applyReauth(linkSubscription),
        createCustomer: applyReauth(createCustomer),
        createIntent: applyReauth(createIntent),
        linkExistingSubscription: applyReauth(linkExistingSubscription),
    };
}
